import { lazy } from "react";
import { Route } from "react-router-dom";

export enum LandingRoutes {
    MAIN = "/",
    INVERSORES = "/inversores",
    DESARROLLADORES = "/desarrolladores",
    BROKERS = "/brokers",
    INMOBILIARIAS = "/inmobiliarias",
}

const LandingPage = lazy(() => import("./LandingPage"));
const InversoresPage = lazy(() => import("./page/InversoresPage"));
const DesarrolladoresPage = lazy(() => import("./page/DesarrolladoresPage"));
const BrokersPage = lazy(() => import("./page/BrokersPage"));
const InmobiliariasPage = lazy(() => import("./page/InmobiliariasPage"));

export const LandingRouter = (
    <>
        <Route path={LandingRoutes.MAIN} element={<LandingPage />} />
        <Route path={LandingRoutes.INVERSORES} element={<InversoresPage />} />
        <Route path={LandingRoutes.DESARROLLADORES} element={<DesarrolladoresPage />} />
        <Route path={LandingRoutes.BROKERS} element={<BrokersPage />} />
        <Route path={LandingRoutes.INMOBILIARIAS} element={<InmobiliariasPage />} />
    </>
);
